import React, {lazy} from 'react';
import {Route} from 'react-router-dom';


import * as staticConstants from '../staticConstants';

import HomePage from './HomePage';
import RootRoutes from '../../../roots/RootRoutes';
import {useIsAuthenticated} from '../../../contexts/Auth';

const ImprintPage = lazy(() => import('./ImprintPage'));
const PrivacyPage = lazy(() => import('./PrivacyPage'));
const TermsConditionsPage = lazy(() => import('./TermsConditionsPage'));


function StaticPages() {

    const isAuthenticated = useIsAuthenticated();

    return (
        <RootRoutes>

            <Route
                element={<ImprintPage/>}
                exact={true}
                path={staticConstants.NAV_IMPRINT}
            />

            <Route
                element={<PrivacyPage/>}
                exact={true}
                path={staticConstants.NAV_PRIVACY}
            />

            <Route
                element={<TermsConditionsPage/>}
                exact={true}
                path={staticConstants.NAV_TERMS_CONDITIONS}
            />

            {!isAuthenticated && (
                <Route
                    element={<HomePage/>}
                    index={true}
                />
            )}

        </RootRoutes>
    );
}


export default StaticPages;
